import { GraphSchema } from '@ta/server';
import {
  UserProfile as TaUserProfile,
  userProfileBrutProps as taUserProfileBrutProps,
} from '@ta/user';

import { CompanyMember } from '../../company/dto/company-member';
import { Owner } from './owner';
import { Tenant, UserFieldVisibility } from './tenant';

export enum Status {
  Unknown = 0,
  Pending = 1,
  Validated = 2,
}
export interface UserStats {
  totalReviews: number;
  totalEstates: number;
  ownerGlobalNote: number | null;
  tenantGlobalNote: number | null;
}

export interface UserProfile extends TaUserProfile {
  bailoId?: string;
  /** Flags de compte : couper l'un ne coupe pas l'autre. Défaut `true` côté serveur. */
  emailNotificationsEnabled?: boolean;
  pushNotificationsEnabled?: boolean;
  fieldVisibilities?: UserFieldVisibility[];
  phoneNumber?: string;
  preferredLanguage?: string;
  trustScore: number;
  profileCompleted: number;
  owner?: Owner;
  tenant?: Tenant;
  status?: Status;
  companyMembership?: CompanyMember;
  /** Tampon gardé avant et après chaque visite que cette personne fait, tous biens confondus. */
  visitBufferMinutes?: number;
}

const props: (keyof UserProfile)[] = [
  'bailoId',
  'emailNotificationsEnabled',
  'pushNotificationsEnabled',
  'fieldVisibilities',
  'phoneNumber',
  'preferredLanguage',
  'trustScore',
  'profileCompleted',
  'owner',
  'tenant',
  'status',
  'companyMembership',
  'visitBufferMinutes',
];

export const userProfileProps = new GraphSchema<UserProfile>(props.concat(taUserProfileBrutProps));
